module.exports = __webpack_public_path__ + "static/img/1.27dff252.png";